import React from 'react';
import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';
import {
    GradesCustomType,
    LimitFieldNameType,
    SportGradesState,
} from 'src/components/SportPopup/SportGrades/SportGradesState';

interface InputPropsType {
    isError: boolean;
}

const Input = styled('input', { label: 'Input' })<InputPropsType>`
    ${(props): string => (props.isError ? 'background-color: #ff000040 !important;' : '')}
`;

interface SportGradesInputPropsType {
    grade: GradesCustomType;
    sportGradesState: SportGradesState;
    templateId: string;
    fieldLimitId: LimitFieldNameType;
    dataTest: string;
}

const SportGradesInput = observer((props: SportGradesInputPropsType) => {
    const { grade, sportGradesState, templateId, fieldLimitId, dataTest } = props;

    const inputState = sportGradesState.valuesInput.get(grade.id).get(templateId).get(fieldLimitId);

    return (
        <div
            className='col-2'
            data-test={`${dataTest}-${templateId}`}
        >
            <Input
                isError={inputState.isError}
                type='text'
                value={inputState.getValue()}
                onChange={(e): void => {
                    inputState.setValue(e.target.value);
                }}
                onBlur={(): void => {
                    sportGradesState.blurValue(grade, templateId).catch((error) => {
                        console.error(error);
                    });
                }}
            />
        </div>
    );
});

interface PropsType {
    sportGradesState: SportGradesState;
    label: string; //TODO - to remove
}

export const SportGrades = observer((props: PropsType) => {
    const { sportGradesState } = props;

    const { marketTemplates, getTemplateKey } = sportGradesState;
    const grades = sportGradesState.grades;
    const grade = sportGradesState.getSelectGrade;

    if (grade === null) {
        return null;
    }

    return (
        <div className='sport-grades'>
            <header className='form'>
                <div className='row'>
                    <div className='element col-3'>
                        <input
                            type='text'
                            value={sportGradesState.getName}
                            onBlur={(): void => {
                                sportGradesState.onNameBlur(grade).catch((error) => {
                                    console.error(error);
                                });
                            }}
                            onChange={(e): void => sportGradesState.onNameChange(e)}
                        />
                    </div>
                    <div className='element col-3'>
                        <select
                            value={grade.id}
                            onChange={(e): void => sportGradesState.toggleGrade(e.target.value)}
                            data-test='grades-list-dropdown'
                        >
                            {grades.map((item) => (
                                <option
                                    value={item.id}
                                    key={item.id}
                                    data-test={`grades-list-dropdown-item ${item.name}`}
                                >
                                    {typeof item.displayName === 'string' ? item.displayName : item.name}
                                    {item.default && ' (default)'}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='col-3'>&nbsp;</div>
                    <div className='element col-3'>
                        <a
                            href='#'
                            className='btn btn-add'
                            onClick={(e): void => {
                                sportGradesState.onCreateGrade(grade, e).catch((error) => {
                                    console.error(error);
                                });
                            }}
                        >
                            Add grade
                        </a>
                    </div>
                </div>
                <br />
            </header>
            <div className='sport-grades__list-header'>
                <div className='row'>
                    <div className='col-3'>Market</div>
                    <div className='col-2'>Max bet</div>
                    <div className='col-2'>Max win</div>
                    <div className='col-2'>Max multiple bet</div>
                    <div className='col-2'>Liability limit</div>
                </div>
            </div>
            <ul className='sport-grades__list'>
                {marketTemplates.map((template) => {
                    const id = getTemplateKey(template);
                    return (
                        <li key={id}>
                            <div className='row element'>
                                <div
                                    className='col-3 sport-grades__name'
                                    data-test='sport-grades-market-name'
                                    data-test-market-template-id={`${id}`}
                                >
                                    {template.marketName}
                                </div>

                                <SportGradesInput
                                    grade={grade}
                                    sportGradesState={sportGradesState}
                                    templateId={id}
                                    fieldLimitId='maxBet'
                                    dataTest='grades-value-max-bet'
                                />

                                <SportGradesInput
                                    grade={grade}
                                    sportGradesState={sportGradesState}
                                    templateId={id}
                                    fieldLimitId='maxWin'
                                    dataTest='grades-value-max-win'
                                />

                                <SportGradesInput
                                    grade={grade}
                                    sportGradesState={sportGradesState}
                                    templateId={id}
                                    fieldLimitId='maxMultipleBet'
                                    dataTest='grades-value-max-multiple-bet'
                                />

                                <SportGradesInput
                                    grade={grade}
                                    sportGradesState={sportGradesState}
                                    templateId={id}
                                    fieldLimitId='liabilityLimit'
                                    dataTest='grades-value-liability-limit'
                                />
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
});
